import { Component, Inject, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { db } from 'src/app/db/db';
import { Taxon } from 'src/app/domain/Analyse/taxon';
import { IBMRProcess } from 'src/app/domain/IBMR/IBMR-process';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';
import { SANDRETaxionModel } from 'src/app/models/SANDRE-taxon-model';
import { IBMRService } from 'src/app/services/ibmr.service';
import { SANDREService } from 'src/app/services/SANDRE-service';
import { TaxonService } from 'src/app/services/taxon-service';
import { CoreData } from '../../core-data';
import { StringConverter } from '../string-converter';
import { TaxonDialogModel } from './taxon-dialog-model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
    selector: 'app-taxon-dialog',
    templateUrl: './taxon-dialog.component.html',
    styleUrls: ['./taxon-dialog.component.scss']
})
export class TaxonDialogComponent implements OnInit {
    EInterventionType = EInterventionType;
    public model: TaxonDialogModel;
    public IsCreation: boolean;
    public PhaseList: number[] = [];
    public TransectList: number[] = [];
    public SearchText: string;
    public TaxonOptionList: SANDRETaxionModel[] = [];
    private subject: Subject<string> = new Subject();
    IsFocused: boolean;
    IsQuantityDisabled: boolean = false;

    // IBMR ONLY
    processIBMR?: IBMRProcess;
    SelectedTaxon?: Taxon;

    get CanAdd() {
        if (this.model.Analyse.Type === EInterventionType.IBMR)
            return this.model.Taxon.Quantite > 0 && this.model.Taxon.NumeroPhase !== 0;
        return (this.model.Taxon.NomOrdre || this.model.Taxon.NomFamille) && this.model.Taxon.Quantite > 0 && this.model.Taxon.NumeroPhase !== 0;
    }

    constructor(
        public CoreData: CoreData,
        private sANDREService: SANDREService,
        private taxonService: TaxonService,
        private ibmrService: IBMRService,
        public dialogRef: MatDialogRef<TaxonDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TaxonDialogModel) {

        this.model = Object.assign({}, data);
        this.model.Taxon = Object.assign({}, data.Taxon);

        this.init(data);
    }

    async init(data: TaxonDialogModel) {
        if (this.model.Analyse.Type === EInterventionType.IBMR) {
            this.model.Taxon.CreatedOn = new Date();
            if (this.CoreData.IsOffline)
                this.processIBMR = this.CoreData.getOfflineProcess(data.ProcessCode) as IBMRProcess;
            else
                await this.getProcessFromServer(data.ProcessCode);
            this.PhaseList.push(...Array.from({ length: this.processIBMR.HasUR2 ? 2 : 1 }, (v, i) => i + 1));
        }

        if (this.model.Taxon.NomGenre === '(presence)') {
            this.IsQuantityDisabled = true;
        }

        if (this.model.Analyse.NombrePhase === 4 || this.model.Analyse.NombrePhase === 3 || this.model.Analyse.NombrePhase === 12 || this.model.Analyse.NombrePhase === 15) {
            this.PhaseList.push(...Array.from({ length: this.model.Analyse.NombrePhase }, (v, i) => i + 1));
            // this.model.Taxon.NumeroPhase = _.min(_.difference(this.PhaseList, this.model.AlreadyPickedPhase));
        }

        this.model.Taxon.NumeroPhase = this.model.LastSelectedPhase;
        if (this.model.Analyse.Type === EInterventionType.IBMR)
            this.refreshTransectList();

        if (this.model.Taxon.SandreCode) { // EDITION
            this.IsCreation = false;
            this.model.Taxon.Quantite = this.getQuantity(this.model.Taxon, this.model.Taxon.NumeroPhase, this.model.Taxon.NumeroTransect);
            // if (this.model.Analyse.Type === EInterventionType.MPCE) {
            //   this.model.Taxon.Quantite = undefined;
            // }
            this.SearchText = this.model.Taxon ? `${this.model.Taxon.SandreCode} - ${this.model.Taxon.NomOrdre && this.model.Taxon.NomOrdre !== '' ? this.model.Taxon.NomOrdre + ' /' : ''} ${this.model.Taxon.NomFamille !== '' ? this.model.Taxon.NomFamille : ''} ${this.model.Taxon.NomGenre ? ' / ' + this.model.Taxon.NomGenre : ''}` : '';
        } else { // CREATION
            this.IsCreation = true;
        }

        setTimeout(() => {
            this.IsFocused = true;
        }, 100);
    }

    ngOnInit(): void {
        this.subject.pipe(
            debounceTime(500)
        ).subscribe((s) => {
            this.searchTaxon(s);
        });
    }

    canChooseTaxon() {
        return this.IsCreation || this.model.Taxon?.CodeIBMR?.startsWith('INCONNU');
    }

    async getProcessFromServer(processCode: string) {

        await new Promise((resolve, reject) => {
            this.ibmrService.getProcessByCode(processCode).subscribe(x => {
                this.processIBMR = x;
                resolve(true);
            });
        })
    }

    getQuantity(tax: Taxon, phaseNum: number, transectNum?: number) {
        if (this.model.Analyse.Type === EInterventionType.IBGN) {
            return tax.Quantite;
        } else if (
            this.model.Analyse.Type === EInterventionType.MPCE ||
            this.model.Analyse.Type === EInterventionType.MGCE) {

            if (this.model.Analyse.NombrePhase === 3) {
                switch (phaseNum) {
                    case 1:
                        return tax.QuantitePhaseA;
                    case 2:
                        return tax.QuantitePhaseB;
                    case 3:
                        return tax.QuantitePhaseC;
                }
            } else {
                switch (phaseNum) {
                    case 1:
                        return tax.Quantite1;
                    case 2:
                        return tax.Quantite2;
                    case 3:
                        return tax.Quantite3;
                    case 4:
                        return tax.Quantite4;
                    case 5:
                        return tax.Quantite5;
                    case 6:
                        return tax.Quantite6;
                    case 7:
                        return tax.Quantite7;
                    case 8:
                        return tax.Quantite8;
                    case 9:
                        return tax.Quantite9;
                    case 10:
                        return tax.Quantite10;
                    case 11:
                        return tax.Quantite11;
                    case 12:
                        return tax.Quantite12;
                    case 13:
                        return tax.Quantite13;
                    case 14:
                        return tax.Quantite14;
                    case 15:
                        return tax.Quantite15;
                }
            }
        } else if (this.model.Analyse.Type === EInterventionType.IBMR) {
            if (phaseNum === 1)
                switch (transectNum) {
                    case 1:
                        return tax.Quantite1;
                    case 2:
                        return tax.Quantite2;
                    case 3:
                        return tax.Quantite3;
                    case 4:
                        return tax.Quantite4;
                    case 5:
                        return tax.Quantite5;
                    case 6:
                        return tax.Quantite6;
                    case 7:
                        return tax.Quantite7;
                    case 8:
                        return tax.Quantite8;
                    case 9:
                        return tax.Quantite9;
                    case 10:
                        return tax.Quantite10;

                }
            else if (phaseNum === 2) {
                switch (transectNum) {
                    case 1:
                        return tax.Quantite11;
                    case 2:
                        return tax.Quantite12;
                    case 3:
                        return tax.Quantite13;
                    case 4:
                        return tax.Quantite14;
                    case 5:
                        return tax.Quantite15;
                    case 6:
                        return tax.Quantite16;
                    case 7:
                        return tax.Quantite17;
                    case 8:
                        return tax.Quantite18;
                    case 9:
                        return tax.Quantite19;
                    case 10:
                        return tax.Quantite20;
                }
            }
        }
    }

    // IsDisabled(i) {
    //   if (!this.model.AlreadyPickedPhase.includes(i + 1)) {
    //     return false;
    //   }
    //   return true;
    // }
    resetQuantity(event: MatSelectChange) {
        this.IsQuantityDisabled = false;
        if (this.model.Taxon.NomGenre === '(presence)') {
            this.model.Taxon.Quantite = 1;
            this.IsQuantityDisabled = true;
            return;
        }
        if (this.model.Analyse.TaxonList.find(x => x.SandreCode === this.model.Taxon.SandreCode && x.NumeroPhase === this.model.Taxon.NumeroPhase)) {
            this.model.Taxon.Quantite = this.model.Analyse.TaxonList.find(x => x.SandreCode === this.model.Taxon.SandreCode && x.NumeroPhase === this.model.Taxon.NumeroPhase).Quantite;
        } else {
            this.model.Taxon.Quantite = undefined;
        }
    }

    onTransectSelectionChange(event: MatSelectChange) {
        this.model.Taxon.Quantite = this.getQuantity(this.model.Taxon, this.model.Taxon.NumeroPhase, this.model.Taxon.NumeroTransect) !== 0 ? this.getQuantity(this.model.Taxon, this.model.Taxon.NumeroPhase, this.model.Taxon.NumeroTransect) : undefined;

    }

    onTaxonSelectionChange(event: MatSelectChange) {
        this.model.Taxon = Object.assign({}, event.value)
        this.model.Taxon.Quantite = undefined;
        this.model.Taxon.NumeroPhase = undefined;
    }

    refreshTransectList() {
        if (this.model.Analyse.Type === EInterventionType.IBMR) {
            this.TransectList = [];
            if (this.model.Taxon.NumeroPhase === 1) { // UR1
                this.TransectList.push(...Array.from({ length: this.processIBMR.IBMRUniteReleve1.IBMRTransectList.length }, (v, i) => i + 1));
            } else { // UR2
                this.TransectList.push(...Array.from({ length: this.processIBMR.IBMRUniteReleve2.IBMRTransectList.length }, (v, i) => i + 1));
            }
        }
    }

    getPhaseName(phase: number) {
        return StringConverter.getPhaseName(phase);
    }

    getBullshitPhaseName(phase: number) {
        return StringConverter.getBullshitPhaseName(phase);
    }

    getIBMRPhaseName(phase: number) {
        return StringConverter.getIBMRPhaseName(phase);
    }

    getMGCEPhaseName(phase: number) {
        return StringConverter.getMGCEPhaseName(phase);
    }

    getIBMRTransectName(index) {
        return `Transect ${index}`
    }

    getQuantiteLabel() {
        return this.model.Analyse.Type === EInterventionType.IBMR ? 'Quantité (%)' : 'Quantité'
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onConfirm() {
        this.create();
    }

    onKeyUp() {
        if (!this.SearchText) {
            this.TaxonOptionList = [];
            return;
        }

        this.subject.next(this.SearchText);
    }

    displayFn(m: SANDRETaxionModel | string): string {
        if (m instanceof SANDRETaxionModel) {
            if (!m.Ordre && !m.Famille) {
                return `${m.Genre}`
            }
            if (m.Genre) {
                return `${m.Ordre && m.Ordre !== '' ? m.Ordre + ' /' : ''} ${m.Famille !== '' ? m.Famille + ' /' : ''} ${m.Genre}`;
            } else {
                return `${m.Ordre && m.Ordre !== '' ? m.Ordre + ' /' : ''} ${m.Famille}`;
            }
        }
        if (typeof (m) === 'string') {
            return m;
        }
    }

    setSelectedTaxon(event: MatAutocompleteSelectedEvent) {
        this.IsQuantityDisabled = false;
        const selectedOption = this.TaxonOptionList.find(x => x.Code === event.option.value.Code);
        if (selectedOption) {
            this.model.Taxon.SandreCode = selectedOption.Code;
            this.model.Taxon.NomFamille = selectedOption.Famille;
            this.model.Taxon.NomOrdre = selectedOption.Ordre;
            this.model.Taxon.NomGenre = selectedOption.Genre;
            this.model.Taxon.Position = selectedOption.Position;
            this.model.Taxon.Instruction = selectedOption.Instruction;
            this.model.Taxon.CodeIBMR = selectedOption.CodeIBMR;
            if (this.model.Analyse.Type === EInterventionType.MPCE && selectedOption.Genre === '(presence)') {
                this.model.Taxon.Quantite = 1;
                this.IsQuantityDisabled = true;
            }
        }
    }

    async searchTaxon(s: string) {

        this.TaxonOptionList = [];
        if (this.CoreData.IsOffline) {
            this.TaxonOptionList = _.differenceWith(await db.getTaxonByFilter(s), this.model.Analyse.MergedTaxonList.map(y => y.SandreCode), this.pouet)

        } else {

            this.sANDREService.getTaxonList(this.model.Analyse.Type, s).subscribe(x => {
                this.TaxonOptionList = _.differenceWith(x, this.model.Analyse.MergedTaxonList.map(y => y.SandreCode), this.pouet);
            });
        }
    }

    pouet(t0, t1) {
        return t0.Code === t1 ? true : false;
    }

    create() {
        if (!this.CanAdd) {
            return;
        }
        if (this.CoreData.IsOffline) {
            const anal = this.CoreData.getOfflineAnalyse(this.model.Analyse.InterventionCode);

            anal.TaxonList.push(this.model.Taxon);

            // if (!anal.TaxonList.find(x => x.UUID === this.model.Taxon.UUID))
            //     anal.TaxonList.push(this.model.Taxon);
            // else {
            //     anal.TaxonList[anal.TaxonList.indexOf(anal.TaxonList.find(x => x.UUID === this.model.Taxon.UUID))] = this.model.Taxon
            //     // conf.LimitCategoryList[conf.LimitCategoryList.indexOf(cat)] = result;
            // }

            this.CoreData.setOfflineAnalyse(this.model.Analyse.InterventionCode, anal)
            this.dialogRef.close(this.model.Taxon);
        } else {

            this.taxonService.create(this.model.Taxon, this.model.Analyse.Code).subscribe((x: string) => {
                this.model.Taxon.Code = x;
                this.dialogRef.close(this.model.Taxon);
            });
        }
    }
}
